<template>
  <div class="no-result-wrapper">
    <div class="no-result">
      <img :src="imgSrc" class="no-result-icon"/>
      <button v-if="noResultButton" class="no-result-btn" @click="$emit('btnClick')">{{noResultButton}}</button>
      <p class="no-result-text">{{noResultTitle}}</p>
    </div>
  </div>
</template>

<script>
	export default {
		props: {
			noResultTitle: {
				type: String,
				default: ''
			},
			imgSrc: {
				type: String,
				default: ''
      },
      noResultButton: {
        type: String,
        default: ''
      }
		}
	}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  .no-result-wrapper {
    height: calc(100vh - 44px);
    padding-top: 15vh;
    box-sizing: border-box;
    position: fixed;
    top: 10vh;
    .no-result {
      text-align: center;
      .no-result-icon {
        width: 89%;
        height: 182px;
        margin: 0 auto;
        object-fit: cover;
      }
      .no-result-text {
        font-size: $font-size-medium;
        color: #677379;
      }
      .no-result-btn {
        padding: 12px 33px;
        background: #ff4f4c;
        color: #fff;
        font-size: 16px;
        border: none;
        border-radius: 2px;
        outline: none;
      }
    }
  }
</style>
